// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

const ThirdPartyIntegrationEbicsBlSettingsController = function ($scope,
                                                        $location,
                                                        ThirdPartyIntegrationSettings,
                                                        ThirdPartyIntegrationSettingsBlEbicsCheckPermissions,
                                                        DownloadService,
                                                        gettext,
                                                        gettextCatalog,
                                                        CountryList) {

    const _txt = function (msg) {
        return gettextCatalog.getString(msg);
    };

    const EBICS_SETTINGS_STATE = Object.freeze({
        'UserNotRegistered': 'UserNotRegistered',
        'UserRegistered': 'UserRegistered',
        'UserActivatedPermissionsCheckUnavailable': 'UserActivatedPermissionsCheckUnavailable',
        'UserActivatedAndPermissionsChecked': 'UserActivatedAndPermissionsChecked',
    });

    const PERMISSIONS_TABLE_ROW_TYPE = Object.freeze({
        'TableHeader':'TableHeader',
        'GroupHeader':'GroupHeader',
        'GroupData':'GroupData'
    });

    const PERMISSIONS_STATUS = Object.freeze({
        'Unknown':'Unknown',
        'Allowed':'Allowed',
        'Forbidden':'Forbidden'
    });

    const generalPermissions=[
        ['HTD', 'Used to download customer and subscriber data. Retrieves information stored by the bank pertaining to the subscriber\'s company.'],
        ['HPB', 'Used to download bank public certificates from the EBICS Banking Server.'],
    ];

    const downloadPermissions=[
        ['C53','Used to download bank-to-customer statement report.'],
        ['HAC','Used to download customer acknowledgment(XML format).'],
        ['CDZ','Used to download Payment Status Reports for SEPA direct debit(XML format).'],
        ['CRZ','Used to download Payment Status Reports for SEPA credit transfer(XML format).'],
    ];

    const uploadPermissions=[
        ['CDD', 'Used to initiate a direct debit transaction.'],
        ['CCT', 'Used to initiate a credit transfer.']
    ];

    const Ebics25VersionCode = 'H004';
    const Ebics30VersionCode = 'H005';

    const protocolVersion =[
        { value: Ebics25VersionCode, name: 'EBICS 2.5' },
        { value: Ebics30VersionCode, name: 'EBICS 3.0' }
    ];

    const camt053Formats = [
        { value: undefined, name: "SEPA XML Camt.053 Auto (selected by bank)" },
        { value: "Camt05300102", name: "SEPA XML Camt.053 (camt.053.001.02)" },
        { value: "Camt05300108", name: "SEPA XML Camt.053 (camt.053.001.08)" }
    ];

    // ISO 3166 country codes + 3-digit EBICS defined issuer codes for globally valid sets of rules
    const extraScopes = [
        { Code: 'GLB',  Name: 'Global'},
        { Code: 'CGI',  Name: 'Corporate'},
        { Code: 'FIN',  Name: 'Finance'},
        { Code: 'BIL',  Name: 'Bilateral'}];
            
    
    const orderTypeBtfMapper = [
        { OrderType: "C53", ServiceName: "EOP", ServiceOption: null,  MsgName: "camt.053", Container: "ZIP"},
        { OrderType: "CDD", ServiceName: "SDD", ServiceOption: "COR", MsgName: "pain.008", Container: null},
        { OrderType: "CCT", ServiceName: "SCT", ServiceOption: null,  MsgName: "pain.001", Container: null},
        { OrderType: "CRZ", ServiceName: "REP", ServiceOption: "SCT", MsgName: "pain.002", Container: "ZIP"},
        { OrderType: "CDZ", ServiceName: "REP", ServiceOption: "SDD", MsgName: "pain.002", Container: "ZIP"},
    ];

    $scope.camt053Formats = camt053Formats;
    $scope.ebicsSettingsState = EBICS_SETTINGS_STATE;
    $scope.permissionsTableRowType = PERMISSIONS_TABLE_ROW_TYPE;
    $scope.permissionsStatus = PERMISSIONS_STATUS;
    var UploadSepaXmlAutomaticallyInitialValue = false;
    var DownloadReconciliationAutomaticallyInitialValue = false;
    var Camt053FileImportFormat = null;
    var Scope = null;
    

    $scope.isSepaXmlAutomaticUploadEnabled = false;
    $scope.isReconciliationAutomaticDownloadEnabled = false;

    $scope.permissionsTable = [];

    $scope.protocolVersion = protocolVersion;
    $scope.isRequesting = false;
    $scope.deletionFailedOnBankSide = false;

    $scope.scopes = [];
    CountryList.getCountries().then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
            var item = response.data[i];
            $scope.scopes.push( { Code:item.TwoLetterCode, Name:item.EN });    
        }
        $scope.scopes = $scope.scopes.concat(extraScopes);
    });

    const fillPermissionsTableIfRequired = (settings)=>{
        if (settings.EbicsSettingsState!==EBICS_SETTINGS_STATE.UserNotRegistered){

            let serverPermissions=[];
            if(settings.UserPermissions) {
                settings.UserPermissions.FetchFileOrderTypes.forEach(v => {serverPermissions.push(v)});
                settings.UserPermissions.SendFileOrderTypes.forEach(v => {serverPermissions.push(v)});
            }
            const getStatus=(value)=>{
                if(serverPermissions==null || serverPermissions.length===0)
                    return PERMISSIONS_STATUS.Unknown;
                if(serverPermissions.some( (e) => e === value))
                    return PERMISSIONS_STATUS.Allowed;
                return settings.EbicsSettingsState === EBICS_SETTINGS_STATE.UserActivatedAndPermissionsChecked
                    ? PERMISSIONS_STATUS.Forbidden
                    : PERMISSIONS_STATUS.Unknown;
            };
            const fillGroupData = (source, description)=>{
                $scope.permissionsTable.push(
                    {'RowType':PERMISSIONS_TABLE_ROW_TYPE.GroupHeader,
                     'Description':_txt(description)});
                source.forEach(value => {
                    $scope.permissionsTable.push(
                        {'RowType':PERMISSIONS_TABLE_ROW_TYPE.GroupData,
                         'OrderType':value[0],
                         'Status': getStatus(value[0]),
                         'Description':_txt(value[1])});
                    });
            };

            $scope.permissionsTable=[{'RowType':PERMISSIONS_TABLE_ROW_TYPE.TableHeader}];

            fillGroupData(generalPermissions,  'General Permissions / Communication');
            fillGroupData(downloadPermissions, 'Download from the bank');
            fillGroupData(uploadPermissions,   'Upload to the bank');

            setAutomaticEbicsActionSettings(settings);
        }
        else $scope.permissionsTable=[];
    };

    function setAutomaticEbicsActionSettings(settings) {
        UploadSepaXmlAutomaticallyInitialValue = settings.AutomaticProcessingSettings.UploadSepaXmlAutomatically;
        DownloadReconciliationAutomaticallyInitialValue = settings.AutomaticProcessingSettings.DownloadReconciliationAutomatically;
        Scope = settings.Scope;
        Camt053FileImportFormat = settings.Camt053FileImportFormat;

        $scope.isSepaXmlAutomaticUploadEnabled = settings.AutomaticProcessingSettings.UploadSepaXmlAutomatically;
        $scope.isReconciliationAutomaticDownloadEnabled = settings.AutomaticProcessingSettings.DownloadReconciliationAutomatically;
    }

    $scope.settingsLoaded = false;
    $scope.isEbicsSettingsValid = function() {
        return $scope.settings && $scope.settings.Valid;
    };

    $scope.getBtfPermissions = function(row) {
        var btfParameters = orderTypeBtfMapper.filter(x => x.OrderType === row.OrderType);
        if(btfParameters.length > 0) {
            return getFieldContent("ServiceName", btfParameters[0].ServiceName) 
                + getFieldContent("ServiceOption",btfParameters[0].ServiceOption) 
                + getFieldContent("MsgName",btfParameters[0].MsgName);
        }
        
        return null;        
    }

    function getFieldContent(header, content) {
        if(content) 
            return header + "=" + content + ";";        
        else
            return "";        
    }

    $scope.getReconciliationTooltipText = function() {
        return $scope.isEbicsSettingsValid()
            ? _txt(gettext("Please go to Payment Settings > On account to enable this payment method"))
            : _txt(gettext("In order to download CAMT0.53-bank account statements from your bank automatically, please configure your housebank-settings and make sure your bank has activated your account."));
    }

    $scope.getSepaXmlUploadText = function() {
        return  $scope.isEbicsSettingsValid()
            ? _txt(gettext("Please go to Payment Settings > Sepa XML to enable this payment method"))
            : _txt(gettext("In order to send SEPAXml to your bank automatically, please configure your housebank-settings and make sure your user has been activated by the bank"));
    }

    function setDefaultProtocolVersion() {
        if  (!$scope.settings.ProtocolVersion)
            $scope.settings.ProtocolVersion = Ebics30VersionCode;
    }
    function setDefaultScope() {
        if (!$scope.settings.Scope)           
            $scope.settings.Scope = "DE";
    }

    function applySettingsToUI(){
        if ($scope.isEbicsSettingsValid()) {
            $('#bankName').attr('readonly','readonly');
            $('#bankUri').attr('readonly','readonly');
            $('#userId').attr('readonly','readonly');
            $('#customerId').attr('readonly','readonly');
            $('#hostId').attr('readonly','readonly');
            $('#protocolVersion').attr('disabled','disabled')

            $('#DownloadInitializationLetterLink').css("display", '');
        }
        fillPermissionsTableIfRequired($scope.settings);
    }

    ThirdPartyIntegrationSettings.get({thirdPartyIntegration: 'BlEbics'}).$promise.then(function (response) {
        $scope.settings = response;
        $scope.settingsLoaded = true;
        setDefaultProtocolVersion();
        setDefaultScope();
        applySettingsToUI();
    });

    $scope.save = function () {
        if(!$scope.isEbicsSettingsValid()) {
            UploadSepaXmlAutomaticallyInitialValue = false;
            DownloadReconciliationAutomaticallyInitialValue = false;
        }

        if (!$scope.settings.Valid) {
            $scope.isRequesting = true;
            $scope.settings.$update({ thirdPartyIntegration: 'BlEbics' }, function () {
                $scope.onlyOk(_txt(gettext("User initialization")), $scope.userRegisteredAlertMsg);
                $scope.checkPermissionStatus(true).then(function () {
                    $scope.isRequesting = false;
                })
                    .catch(e => {
                        $scope.isRequesting = false;
                    });
            })
                .catch(e => {
                    $scope.isRequesting = false;
                });
        }
        else if ($scope.settings.AutomaticProcessingSettings.DownloadReconciliationAutomatically === true
            && $scope.settings.AutomaticProcessingSettings.MissedDownloadFromDate != null) {
            var date = new Date($scope.settings.AutomaticProcessingSettings.MissedDownloadFromDate);
            var dateString = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            $scope.yesCancel(_txt(gettext("Risk disclosure")), _txt(gettext($scope.ebicsPotentialMissedDownloadMsg.replace("{date}", dateString))), () => updateSettings(), () => { });
        }
        else {
            updateSettings();
        }
    };

    function updateSettings() {
        var settings = {
            Scope: $scope.settings.Scope,
            Camt053FileImportFormat: $scope.settings.Camt053FileImportFormat,
            AutomaticProcessingSettings: {
                UploadSepaXmlAutomatically: $scope.settings.AutomaticProcessingSettings.UploadSepaXmlAutomatically,
                DownloadReconciliationAutomatically: $scope.settings.AutomaticProcessingSettings.DownloadReconciliationAutomatically
            }
        };

        $scope.isRequesting = true;
        ThirdPartyIntegrationSettingsBlEbicsCheckPermissions.updateEbicsConfiguration(settings).then(function (response) {
            $scope.settings.AutomaticProcessingSettings.MissedDownloadFromDate = null;
            applySettingsToUI();
            $scope.isRequesting = false;
            $scope.onlyOk(_txt(gettext("Configuration update")), $scope.ebicsConfigurationUpdated);
        })
        .catch(e => {
            $scope.isRequesting = false;
        });
    }

    $scope.download = function (pdfId, searchByName) {
        var downloadInfo = new DownloadService();
        $scope.isRequesting = true;

        downloadInfo.$get({ id: pdfId, searchByName: searchByName },
            function () {
                window.location = downloadInfo.Url;
                $scope.isRequesting = false;
            })
            .catch(e => {
                $scope.isRequesting = false;
            });
    };

    function confirmRemoveConnection(header, deleteCallback) {
        $scope.yesCancel(header, _txt(gettext("Are you sure you want to remove your EBICS settings? \nIf you remove your settings, you will not be able to exchange data with your bank anymore. \nTo revoke your connection with the bank completely, you need to contact your bank in order to block your EBICS-access.")),
            function() { deleteCallback(); });
    }

    function confirmResetSettings(header, deleteCallback) {
        $scope.yesCancel(header, _txt(gettext("Are you sure you want to reset settings? \nPlease keep in mind that this action will completely remove the settings on billwerk side without removing it on bank side.")),
            function() { deleteCallback(); });
    }

    $scope.removeConnection = function() {
        confirmRemoveConnection(_txt(gettext("Remove EBICS Connection")),
            function() {
                $scope.isRequesting = true;
                ThirdPartyIntegrationSettings.remove({ thirdPartyIntegration: 'BlEbics', forceSettingsDelete: false }).$promise
                    .then(function() {
                        $scope.isRequesting = false;
                        $location.path("/settings/thirdparty-integration");
                    })
                    .catch(function(e) {
                        $scope.isRequesting = false;
                        $scope.deletionFailedOnBankSide = true;
                    });
            });
    };

    $scope.resetSettings = function() {
        confirmResetSettings(_txt(gettext("Reset Settings")),
            function() {
                $scope.isRequesting = true;
                ThirdPartyIntegrationSettings.remove({ thirdPartyIntegration: 'BlEbics', forceSettingsDelete: true }).$promise
                    .then(function() {
                        $scope.isRequesting = false;
                        $location.path("/settings/thirdparty-integration");
                    })
                    .catch(function(e) {
                        $scope.isRequesting = false;
                    });
            });
    };

    $scope.checkPermissionStatus = function(skipPopUp = false) {
        $scope.isRequesting = true;
        return ThirdPartyIntegrationSettingsBlEbicsCheckPermissions.refreshUserPermissions().then(
            function (response) {
                $scope.isRequesting = false;
                const permissionsMessage = response.data.EbicsSettingsState === EBICS_SETTINGS_STATE.UserRegistered
                    ? _txt(gettext("Your user has not yet been activated by the bank. Please contact your bank."))
                    : response.data.EbicsSettingsState === EBICS_SETTINGS_STATE.UserActivatedAndPermissionsChecked
                        ?_txt(gettext("Your user has been activated by the bank.")) + " "+ $scope.userActivatedAlertMsg
                        : $scope.userActivatedButPermissionsDoesNotDisclosedWarningMsg;
                $scope.settings = response.data;
                applySettingsToUI();
                if(!skipPopUp)
                    $scope.onlyOk(_txt(gettext("User Permission Status")), permissionsMessage);
            })
            .catch(e => {
                $scope.isRequesting = false;
            });
    };

    $scope.triggerReconciliationAutomaticDownload = function() {
        $scope.isReconciliationAutomaticDownloadEnabled = $scope.settings.DownloadReconciliationAutomatically;
    }

    $scope.onAutomatiUploadChange = function() {

        if($scope.settings.AutomaticProcessingSettings.UploadSepaXmlAutomatically) {
            $scope.settings.AutomaticProcessingSettings.DownloadReconciliationAutomatically = true;
        }
    }

    $scope.triggerSepaXmlAutomaticUpload = function() {
        $scope.isSepaXmlAutomaticUploadEnabled = $scope.settings.UploadSepaXmlAutomatically;
    }

    $scope.isSaveDisabled = function() {
        if($scope.isEbicsSettingsValid() &&
            !( $scope.settings.AutomaticProcessingSettings.UploadSepaXmlAutomatically !== UploadSepaXmlAutomaticallyInitialValue 
                || $scope.settings.AutomaticProcessingSettings.DownloadReconciliationAutomatically !== DownloadReconciliationAutomaticallyInitialValue
                || $scope.settings.Camt053FileImportFormat !== Camt053FileImportFormat 
                || $scope.settings.Scope !== Scope)) {
                return true;
        }
        else {
            return false;
        }
    }

    $scope.isTableHeader = function(row) {
        return isRowItemOfType(row.RowType, $scope.permissionsTableRowType.TableHeader);
    }

    $scope.isGroupHeader = function(row) {
        return isRowItemOfType(row.RowType, $scope.permissionsTableRowType.GroupHeader);
    }

    $scope.isGroupData = function(row) {
        return isRowItemOfType(row.RowType, $scope.permissionsTableRowType.GroupData);
    }

    function isRowItemOfType(rowItem, type) {
        return rowItem === type;
    }

    $scope.isStatusUnknown = function(row){
        return isRowItemOfStatus(row.Status, $scope.permissionsStatus.Unknown);
    }

    $scope.getRowGroupDataClass = function(row) {
        var result = '';
        if(row.Status === $scope.permissionsStatus.Allowed) {
            result = 'label-success';
        }
        else if (row.Status === $scope.permissionsStatus.Forbidden) {
            result = 'label-important';
        }
        return result;
    }

    $scope.arePermissionsUnavailable = function() {
        return $scope.settings && 
            ($scope.settings.EbicsSettingsState === $scope.ebicsSettingsState.UserActivatedPermissionsCheckUnavailable);
    }

    function isRowItemOfStatus(rowItemStatus, status) {
        return rowItemStatus === status;
    }

    $scope.isTableHeaderAllowesBtf = function(row) {
        return $scope.settings.ProtocolVersion === Ebics30VersionCode &&
                isRowItemOfType(row.RowType, $scope.permissionsTableRowType.TableHeader) ;
    }

    $scope.isEbicsVersion25 = function() {
        return $scope.settings.ProtocolVersion === Ebics25VersionCode;
    }

    $scope.isEbicsVersion30 = function() {
        return $scope.settings.ProtocolVersion === Ebics30VersionCode;
    }
    
    $scope.userNotRegisteredAlertMsg = _txt(gettext("EBICS allows you to process SEPA Direct Debit transactions and reconciliation of on account-payments without a PSP. To activate it, please ensure that you have a valid agreement with your bank about the use of EBICS. Once configured, you will receive an 'initialization letter' as PDF which you need to print out, sign and mail or fax to your bank."));

    $scope.userRegisteredAlertMsg = _txt(gettext("The initialization of your EBICS-user was successful. Please download the provided 'initialization letter' PDF, print it out, sign it and mail or fax it to your bank. Please be aware that the activation by your bank may take some time. After your EBICS connection has been activated by your bank, you can use it to send direct debit files (SEPA.xml) to your bank for processing and import reconciliation files into billwerk. You will also need to request the transmission of the files regularly in 'Activities / Payments Export' or 'Activities / Account Reconciliation'. Alternatively, you can activate automated daily processing below."));

    $scope.userActivatedAlertMsg = _txt(gettext("Please request the transmission of the files regularly in 'Activities / Payments Export' or 'Activities / Account Reconciliation'. Alternatively, you can activate automated daily processing below."));

    $scope.userActivatedButPermissionsDoesNotDisclosedWarningMsg = _txt(gettext("Your bank does not disclose your user's permissions. You can try to use all EBICS-features within Frisbii, but might encounter permission-related difficulties. In that case, please contact your bank to grant you necessary permissions."));

    $scope.ebicsConfigurationUpdated = _txt(gettext("Ebics configuration is successfully updated."));

    $scope.ebicsPotentialMissedDownloadMsg = "There are failed automatic downloads from {date}. By turning on automatic account reconciliation again, you take the responsibility to manually cover the dates prior to 30 days from today. Please bear in mind that older account reconciliation data may not be available from the bank anymore.";

    $scope.resetSettingsButtonInfo = _txt(gettext(
        "Scenarios when this button should be used:\n" +
        "1. Account has been expired.\n\n" +
        "2. Bank stopped supporting this Ebics protocol.\n\n" +
        "3. Bank service is not available."
    ));
};

ThirdPartyIntegrationEbicsBlSettingsController.$inject = ['$scope', '$location', 'ThirdPartyIntegrationSettings',
    'ThirdPartyIntegrationSettingsBlEbicsCheckPermissions', 'DownloadService',
    'gettext', 'gettextCatalog', 'CountryList'];
